module.exports = __webpack_public_path__ + "static/kitgob-98a9eb56c2ca2cf8cda47248f2b63fee.png";